// extracted by mini-css-extract-plugin
export default {"content":"Tooltip_content__hKN5w","text":"Tooltip_text__Fm93x","open":"Tooltip_open__kwjfT","close":"Tooltip_close__6uVO5"};